import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMixComponent } from './simple-icons-mix.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMixComponent ],
    exports:      [ SimpleIconsMixComponent ],
    bootstrap:    []
})
export class SimpleIconsMixModule {}
